import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import './SendMessageToDriver.css';

const SendMessageToDriver = () => {
  const [driverId, setDriverId] = useState('');
  const [message, setMessage] = useState('');
  const [drivers, setDrivers] = useState([]);

  useEffect(() => {
    const fetchDrivers = async () => {
      const snapshot = await getDocs(collection(db, 'drivers'));
      setDrivers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchDrivers();
  }, []);

  const handleSend = async () => {
    if (!driverId || !message) return alert("يرجى اختيار سائق وكتابة الرسالة");

    await addDoc(collection(db, 'admin_messages'), {
      driverId,
      message,
      timestamp: new Date(),
      status: 'new',
    });

    setMessage('');
    alert('✅ تم إرسال الرسالة بنجاح!');
  };

  return (
    <div className="admin-page">
      <AdminSidebar />
      <div className="content">
        <h2>✉️ إرسال رسالة إلى سائق</h2>
        <select value={driverId} onChange={e => setDriverId(e.target.value)}>
          <option value="">-- اختر سائق --</option>
          {drivers.map(driver => (
            <option key={driver.id} value={driver.id}>
              {driver.name || 'بدون اسم'}
            </option>
          ))}
        </select>
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="اكتب رسالتك هنا..."
        />
        <button onClick={handleSend}>إرسال</button>
      </div>
    </div>
  );
};

export default SendMessageToDriver;
